<script setup lang="ts">
  import { ref, watch } from 'vue'
  import { debounce } from '@/functions'

  const modelValue = defineModel<string>({ default: '' })

  const search = ref(modelValue.value)

  defineProps<{
    placeholder?: string,
    label?: string,
    loading?: boolean,
  }>()

  const submitSearch = debounce(() => {
    modelValue.value = search.value
  }, 500)

  watch(search, (searchValue) => {
    if (!searchValue) {
      submitSearch.trigger()
    } else {
      submitSearch()
    }
  })
</script>

<template>
  <app-input
    v-model="search"
    type="search"
    :placeholder="placeholder ?? 'Cari...'"
    :label="label ?? 'Cari'"
    @keyup.enter="submitSearch.trigger()">
    <template #inline>
      <div class="absolute flex-center text-sm text-gray-300 w-9">
        <fa-icon icon="i-far-magnifying-glass" />
      </div>
      <div class="absolute right-1 flex items-center text-xs z-10 text-gray-600 inset-y-0">
        <div
          v-if="loading"
          class="flex-center h-6 w-6">
          <fa-icon
            icon="i-fas-circle-notch"
            class="animate-spin" />
        </div>
        <app-button
          v-else-if="search"
          class="h-6 w-6 flex-center rounded-full hover:bg-gray-200"
          @click="search = ''">
          <fa-icon icon="i-fas-xmark" />
        </app-button>
      </div>
    </template>
  </app-input>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep(input) {
    @apply pl-9 pr-8 placeholder-shown:pr-4;
  }
</style>
